import { CUSTOM_CATEGORY_OPTIONS } from './makeupCustomOptions';

export function normalizeOptionId(id) {
  const s = String(id || '').trim();
  if (/^#[0-9A-Fa-f]{6}$/i.test(s)) {
    return s.startsWith('#') ? s.toUpperCase() : `#${s.toUpperCase()}`;
  }
  return s;
}

export function findCatalogOption(category, optionId) {
  const options = CUSTOM_CATEGORY_OPTIONS[category] || [];
  const want = normalizeOptionId(optionId);
  return options.find((o) => normalizeOptionId(o.id) === want) || null;
}
